import { withInstall } from '../utils/index';
import Image from './index.vue';
import './index.less';

export const TlbsImage = withInstall(Image);
export default TlbsImage;
